module.exports = __webpack_public_path__ + "img/theatre_2.623092d1.jpg";